import type { LocationQuery, LocationQueryRaw } from "vue-router";

/**
 * Where the training form is mounted by the page itself, and owns its `?id=` deep link. Everywhere
 * else the form is hosted at the root (`app.vue`), so the assistant opens a pre-filled training in
 * place instead of routing the admin to the catalog — and the form leaves the host page's query
 * alone rather than writing a training id into one the page reads for something else.
 */
const TRAINING_MODAL_HOST_ROUTES = ["/company-catalog", "/my-catalog"];

/** `/settings` renders its sections in place: there, the section is what mounts the container. */
const TRAINING_MODAL_HOST_SECTION = "simbel-catalog";

export function hostsTrainingModal(route: { path: string; query: Record<string, unknown> }): boolean {
  return TRAINING_MODAL_HOST_ROUTES.includes(route.path) || route.query.section === TRAINING_MODAL_HOST_SECTION;
}

/** The form's own key in a host page's query — the only one it may add or take away. */
const TRAINING_MODAL_QUERY_KEY = "id";

/**
 * The host page's query with the form's `?id=` taken out, and nothing else: a query replaced whole
 * would drop `?section=` too, and the settings page reads that key to know which section it shows.
 */
export function queryWithoutTrainingId(query: LocationQuery): LocationQueryRaw {
  return Object.fromEntries(Object.entries(query).filter(([key]) => key !== TRAINING_MODAL_QUERY_KEY));
}
